import { createRoot } from "react-dom/client"
import "@/i18n"
import "@scss/styles.scss"
import "react-bootstrap-typeahead/css/Typeahead.css"
import "react-bootstrap-typeahead/css/Typeahead.bs5.css"
import "react-calendar/dist/Calendar.css"
import { BrowserRouter as Router } from "react-router-dom"
import { BACKEND_URL, ENABLE_SENTRY, SENTRY_ENVIRONMENT, IS_DEV, SENTRY_DSN, VERSION, ROUTER_BASE_PATH } from "@/const"
import { PersistGate } from "redux-persist/integration/react"
import { Provider } from "react-redux"
import { Toaster } from "react-hot-toast"
import axios from "axios"
import { persistStore } from "redux-persist"
import store from "./store"
import { ErrorBoundary } from "react-error-boundary"
import LoadingWithProgress from "@views/LoadingWithProgress"
import * as Sentry from "@sentry/react"
import ErrorPage from "@views/ErrorPage"
import App from "./App"
import { initializeAuth } from "@myeway/auth"
import { initializeTheme } from "@utils/theme/themeUtils.ts"

initializeTheme()

if (ENABLE_SENTRY) {
	Sentry.init({
		dsn: SENTRY_DSN,
		release: VERSION,
		environment: SENTRY_ENVIRONMENT,
		sendDefaultPii: false,
	})
}

initializeAuth({
	backendUrl: BACKEND_URL,
	platform: "web",
})

const persistor = persistStore(store)
window.store = store

axios.defaults.baseURL = BACKEND_URL

const tree = (
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<Router basename={ROUTER_BASE_PATH ? ROUTER_BASE_PATH : "/"}>
				<App />
			</Router>
		</PersistGate>
		<Toaster />
		<LoadingWithProgress />
	</Provider>
)

const rootElement = document.getElementById("root")!
const root = createRoot(rootElement, {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error(error, errorInfo.componentStack)
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
})

root.render(
	IS_DEV ? (
		tree
	) : (
		<Provider store={store}>
			<ErrorBoundary
				fallbackRender={({ error }) => <ErrorPage error={error instanceof Error ? error : new Error(String(error))} />}
			>
				{tree}
			</ErrorBoundary>
		</Provider>
	)
)
